import { render, staticRenderFns } from "./EditAnnouncementDialog.vue?vue&type=template&id=12fe9888"
import script from "./EditAnnouncementDialog.vue?vue&type=script&lang=js"
export * from "./EditAnnouncementDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports